import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { AddressKeys } from './types'

interface Scheme {
    id: AddressKeys
}

export const AddressForm: {
    input?: InputBuildProps & Scheme
    layout: LayoutProps
    select?: SelectBuildProps & Scheme
}[] = [
    {
        input: {
            id: 'cep',
            label: 'CEP',
            required: true,
            maskReplace: 'cep',
            inputMode: 'numeric'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        select: {
            id: 'uf',
            label: 'UF',
            required: true,
            optionsType: 'uf',
            isSearching: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
        }
    },
    {
        input: {
            id: 'logradouro',
            label: 'Logradouro',
            required: true,
            isSearching: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 7 }
        }
    },
    {
        input: {
            id: 'numero',
            label: 'Número',
            required: true,
            isSearching: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'municipio',
            label: 'Cidade',
            required: true,
            isSearching: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'bairro',
            label: 'Bairro',
            required: true,
            isSearching: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'complemento',
            label: 'Complemento ou referência',
            isSearching: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 8 }
        }
    },
    {
        select: {
            id: 'tipoEndereco',
            label: 'Tipo de endereço',
            required: true,
            optionsType: 'typeAddress'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    }
]
